<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!ruleList.length"
    :showHeader="showHeader"
  >
    <v-text-field
      :data-cy="`${entityName}__textFieldNumeric--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="ruleList"
      :solo="styleMap.solo"
      clearable
      required
      type="number"
      @input="overrideUpdateValue"
      v-model="value"
    ></v-text-field>
  </component-wrapper>
</template>

<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  methods: {
    overrideUpdateValue(inputComponentValue) {
      const { attributeName } = this;

      const castedValue = parseInt(inputComponentValue, 10);

      if (Number.isNaN(castedValue)) {
        const errMsg = `Failed to parse input for ${attributeName}.`;

        this.$notifyError({
          message: errMsg,
        });
        throw new Error(errMsg);
      }

      this.$set(this, "value", castedValue);
    },
  },
  mixins: [userInputMixin],
  props: {
    ruleList: {
      default: () => {
        return [v => (!!v && v.length > 0) || "Requires a value"];
      },
      type: [Array],
    },
  },
};
</script>
